import {DataGridProvider} from "../../core/components/data-grid/DataGridContext";
import HL7MessageGrid from "../../app/hl7/hl7-data-grid/HL7MessageGrid";
import LayoutWithSider from "../../core/components/layout/layout-with-sider/LayoutWithSider";
import {Card} from "antd";
import HL7Filter from "../../app/hl7/hl7-data-grid/HL7Filter";
import {DATE_OPTIONS, getBeginStr, getDateFromNow, getEndStr} from "../../core/utils/date-utils";
import {useEffect} from "react";
import {t} from "i18next";
import AppConfig from "../../core/service/AppConfig";
import GridFilterCard from "../../core/components/data-grid/GridFilterCard";

export default function HL7GridPage() {
    const getDefaultDate = () => {
        const date = getDateFromNow(DATE_OPTIONS.TODAY);
        return [date.start, date.end]
    }

    const date = getDefaultDate();

    useEffect(() => {
        document.title = `${t('HL7 Messages')} | ${AppConfig.getRisTitle()}`
    }, []);

    return (
        <>
            <DataGridProvider
                defaultFilter={{
                    beginDate: getBeginStr(date[0]),
                    endDate: getEndStr(date[1]),
                    messageType: 0,
                    hl7Status: 0
                }}
            >
                {/* Filtre yan panel yerine grid'in üstünde ayrı kart. */}
                <LayoutWithSider fullWidth={true}>
                    <GridFilterCard>
                        <HL7Filter />
                    </GridFilterCard>
                    <Card title={'HL7 Messages'}>
                        <HL7MessageGrid />
                    </Card>
                </LayoutWithSider>
            </DataGridProvider>
        </>
    )
}
